import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { EndpointConfig } from "src/app/config/endpoint-config";
import { Feedback, FeedbackRequest, FeedbackSummary } from "src/app/model/feedback/feedback";


@Injectable()
export class FeedbackApiService {

    constructor(
        private http: HttpClient,
        private endpointConfig: EndpointConfig,
    ) {}

    public postFeedback (
        projectName: string,
        datasetId: string,
        payload: FeedbackRequest
    ): Observable<Feedback> {
        let url = this.endpointConfig.riaApi.project.projectName.feedback.getUrl(projectName, datasetId)

        return this.http.patch<Feedback>(url, payload)
    }

    public getFeedback(
        projectName: string,
        datasetId: string
    ): Observable<Feedback> {
        let url = this.endpointConfig.riaApi.project.projectName.feedback.getUrl(projectName, datasetId)

        return this.http.get<Feedback>(url)
    }

    public getFeedbackSummary(
        projectName: string
    ): Observable<FeedbackSummary> {

        let url = this.endpointConfig.riaApi.project.projectName.feedback.summary.getUrl(projectName)
        return this.http.get<FeedbackSummary>(url)
    }

}